// extracted by mini-css-extract-plugin
module.exports = {"doc-template-wrapper":"style_doc-template-wrapper__g6ggg","doc-template-container":"style_doc-template-container__L5LzC","anchor":"style_anchor__7HfYh"};